import { FC, Fragment } from 'react';
import { Redirect, Route, RouteProps } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

export const ProtectedRoute: FC<RouteProps> = ({ children, ...rest }: any) => {
    const routeProps = rest as RouteProps;

    return (
        <Fragment>
            <AuthenticatedTemplate>
                <Route
                    {...rest}
                >
                    {children}
                </Route>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <Redirect to={{ pathname: '/auth/login', state: { redirectUrl: routeProps.location?.pathname } }} />
            </UnauthenticatedTemplate>
        </Fragment>
    );
}